import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import { defaultTimeParts } from './dateUtils'

const convertDateForPicker = (date: MaterialUiPickersDate | Date) => {
  let newDate = date

  if (date) {
    newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), ...defaultTimeParts())
  }

  return newDate
}

export default convertDateForPicker
